import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Configuration extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Configuration'
  // Define default properties here
  static instanceDefaults() {
    return {
      config: null,
      config_file_id: null
    }
  }
}

const servicePath = 'configuration'
const servicePlugin = makeServicePlugin({
  Model: Configuration,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin